export const COLORS = {
  tuv_r_blue: "#0071B9",
  tuv_r_blue_20: "#CCE2F1",
  tuv_r_blue_40: "#99C5E3",
  tuv_r_blue_60: "#66A8D5",
  tuv_r_black_10: "#E6E6E6",
  tuv_r_black_30: "#B3B3B3",
  tuv_r_black_50: "#808080",
  tuv_r_black_70: "#4D4D4D",
  tuv_r_black_80: "#333333",
  tuv_r_black_90: "#191919",
  tuv_r_red: "#D20033",
  tuv_r_red_light: "#cf637d",
  tuv_r_red_dark: "#b3022d",
  tuv_r_green: "#50B400",
  tuv_r_blue_dark: "#197DC0",
  orange: "#f18700",
};
